import dayjs from 'dayjs'

// The tablet app writes a heartbeat (`timestamp`, unix seconds) into its Firebase client
// node; without a heartbeat for this long the app counts as not running.
export const TABLET_APP_RUNNING_MINUTES = 35

export function isTabletAppRunning(timestamp, now = dayjs()) {
    if (!timestamp) return false
    return dayjs
        .unix(timestamp)
        .isAfter(now.subtract(TABLET_APP_RUNNING_MINUTES, 'm'))
}

export default {
    TABLET_APP_RUNNING_MINUTES,
    isTabletAppRunning,
}
